var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconJeep = function SvgIconJeep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.772 2.75h14.46a1.75 1.75 0 0 1 1.727 1.507v.002L21.493 8H22.5a1 1 0 1 1 0 2h-.875v9.5a1.75 1.75 0 0 1-1.75 1.75h-2.25a1.75 1.75 0 0 1-1.75-1.75v-2h-7.75v2a1.75 1.75 0 0 1-1.75 1.75h-2.25a1.75 1.75 0 0 1-1.75-1.75V10H1.5a1 1 0 0 1 0-2h1.007l.534-3.74v-.003A1.75 1.75 0 0 1 4.77 2.75zM4.375 10v5.5H7.25v-2.75a1 1 0 1 1 2 0v2.75H11v-2.75a1 1 0 1 1 2 0v2.75h1.75v-2.75a1 1 0 1 1 2 0v2.75h2.875V10zm15.097-2H4.528l.463-3.25h14.018zm-.494-3.466v.002zm.647 12.966h-1.75v1.75h1.75zm-13.5 0h-1.75v1.75h1.75z",
    clipRule: "evenodd"
  })));
};
export default SvgIconJeep;